import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from '../../../utils/withRouter';
import { isEmpty } from 'lodash';
import { bindActionCreators, Dispatch } from 'redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import memoizeOne from 'memoize-one';

import { RootState } from '../../../reducers';
import * as _actionsJourney from '../../../actions/journey1';
import * as _actionsSearch from '../../../actions/search';
import * as _actionsMap from '../../../actions/map';
import * as _actionsProduct from '../../../actions/product';
import * as _actionsFilters from '../../../actions/filters';
import * as _actionsBasket from '../../../actions/basket';
import * as _actionsUi from '../../../actions/ui';
import Map from '../../../components/MapOverviewContainer/index';
import { LocationSearchInput } from '@repo/apg-ui';
import './Step1.scss';
import * as _actions from '../../../actions/index';
import { TypeContainer } from '../../../actions/typeContainer';
import BottomNavigation from '../../../components/BottomNavigation';
import * as _actionsSujet from '../../../actions/sujet';
import Spinner from '../../../components/Spinner';
import SpinnerV2 from '../../../components/SpinnerV2';
import { useNavigate } from 'react-router-dom';
import { parseToApiDate } from '../../../utils/react';
import { geocodeByAddress } from 'react-places-autocomplete';
import { PartiallyIntegratedUserDataEC } from '../../../reducers/app';

interface Props {
  dispatch: any;
  actionsJourney: typeof _actionsJourney;
  actionsBasket: typeof _actionsBasket;
  actionsFilters: typeof _actionsFilters;
  actionsProduct: typeof _actionsProduct;
  actionsSujet: typeof _actionsSujet;
  actionsUi: typeof _actionsUi;
  intl: any;
  readyToRender: boolean;
  locales: any;
  history: any;
  userDataEC: PartiallyIntegratedUserDataEC;
  loading: { map?: boolean; step?: boolean };
  validationMessageConfig: any;
  containers: TypeContainer;
  actionsSearch: typeof _actionsSearch;
  actionsMap: typeof _actionsMap;
  router: any;
  keycloakReady: boolean;
}

const Step1 = ({
  actionsFilters,
  actionsSearch,
  actionsMap,
  actionsProduct,
  actionsBasket,
  actionsJourney,
  actionsSujet,
  actionsUi,
  loading,
  router,
  readyToRender,
  userDataEC,
  keycloakReady,
  intl,
}: Props) => {
  const isDisableButton = (locations: any) => isEmpty(locations);
  const navigate = useNavigate();
  // const [hideImportedTag, setHideImportedTag] = useState(false);
  const memoizedIsDisableButton = memoizeOne(isDisableButton);

  useEffect(() => {
    const query = new URLSearchParams(router.location.search) as any;

    if (query.get('basketId') && query.get('basketreference')) {
      const basket = query.get('basketId');
      const basketreference = query.get('basketreference');

      actionsUi.setLoading({ value: true, name: 'step' });

      actionsBasket.getBasketContent({
        basket,
        basketreference,
      });

      actionsBasket
        .fetchBasketInfo({
          basket,
          basketreference,
        })
        .catch((error) => {
          console.error('Error', error);
          actionsUi.setLoading({ value: false, name: 'step' });
        })
        .then(() => {
          actionsBasket
            .getBasketDefinition({
              basket: query.get('basketId'),
              basketreference: query.get('basketreference'),
            })
            .catch((error) => {
              console.error('Error', error);
              actionsUi.setLoading(false);
            })
            .then(
              (definition: {
                availability: { startdate: any; duration: any };
                coordinate: any[];
                customer: any[];
                basket: any;
                name: any;
                industry: { code: any };
                branche: number;
                branchecode: string;
                branchelabel: string;
              }) => {
                if (definition) {
                  definition.availability &&
                    actionsFilters.updateStartDate([
                      parseToApiDate(definition.availability.startdate),
                      definition.availability.duration,
                    ]);

                  definition.coordinate.forEach((loc) => {
                    geocodeByAddress(loc.name)
                      .then((results) => {
                        actionsSearch.addLocation({
                          ...loc,
                          ...results[0],
                          lngLtd: {
                            lat: loc.latitude,
                            lng: loc.longitude,
                          },
                        });
                        actionsUi.setLoading({ value: false, name: 'step' });
                        actionsBasket.openBasket();
                      })
                      .catch((error) => {
                        console.error('Error', error);
                        actionsUi.setLoading({ value: false, name: 'step' });
                      });
                  });

                  let customer: any;
                  if (definition.customer) {
                    if (definition.customer instanceof Array) {
                      customer = definition.customer[0];
                    } else {
                      customer = definition.customer;
                    }
                  }
                  // The basket's customer has no industry fields, unlike the agency customer list entries
                  actionsSujet.setAgencyData({
                    basketId: definition.basket,
                    campaignName: definition.name,
                    customer: customer && {
                      ...customer,
                      brcid: definition.branche,
                      branche: definition.branchecode,
                      branchelabel: definition.branchelabel,
                    },
                  });

                  if (definition.industry) {
                    // The prefetched big5 set doesn't contain this basket's industry yet
                    actionsFilters.fetchIndustries({ context: 'big5', basket, basketreference });
                    actionsFilters.updateIndustry(definition.industry.code);
                  }
                }
              },
            );
        });
    }
  }, []);

  const onAddressSelection = (
    address: string,
    lngLtd: { lat: number; lng: number },
    types: string[],
    product?: any,
    context?: string,
    radius?: number,
    radiusUnit?: string,
  ) => {
    actionsJourney.addLocation({
      address,
      lngLtd,
      types,
      product,
      context,
      radius,
      radiusUnit,
    });
    if (product && product?.id && context !== 'place') {
      actionsJourney.fetchLocationPolygonalByUrn({
        code: product.id,
        address: address,
      });
    } else if (context === 'place') {
      actionsJourney.fetchLocationPolygonalByUrn({
        name: address,
        longitude: lngLtd.lng.toString(),
        latitude: lngLtd.lat.toString(),
        address: address,
      });
    }
  };

  return (
    <div className='step1-journey2'>
      <div>
        <div className='header'>
          <h4 className='title-journey'>
            <FormattedMessage id='ec.journey02.step01.header' defaultMessage='Planung' />
          </h4>
        </div>

        {loading?.step ? (
          <SpinnerV2 fullScreen />
        ) : (
          <div className='d-flex mt-4 flex-row flex-wrap mapContainer'>
            <p className='text-left align-self-center me-48 w-100 sub-title'>
              <FormattedMessage
                id='ec.journey02.step01.text'
                defaultMessage="In welchem Gebiet wollen Sie werben? Geben Sie hier Adressen, Orte, Kantone, PLZ, Verkehrsbetriebe oder Produkt-ID's ein."
              />
            </p>

            <div className='w-100 p-relative mt-24 autoSearch'>
              {readyToRender && (
                <LocationSearchInput
                  hideImport={false}
                  locations={userDataEC.locations}
                  placeholder={intl.formatMessage({
                    id: 'ec.journey01.step01.locationInputPlaceholder',
                    defaultMessage: 'Klicken und Suchbegriff eingeben',
                  })}
                  getProduct={(id: string) => actionsProduct.fetchProductByUrn({ urn: id })}
                  onRemoved={(address: string) => actionsJourney.removeLocation(address)}
                  onSelected={onAddressSelection}
                  onUpdate={(address: string, radius: number, radiusUnit: string) =>
                    actionsJourney.updateLocation({
                      address,
                      radius,
                      radiusUnit,
                    })
                  }
                  getSearchResults={(payload) => {
                    return actionsSearch.getSearchResults(payload);
                  }}
                  highlightedLocation={userDataEC.highlightedLocation}
                  onHighlightLocation={(urn: string) => actionsSearch.highlightLocation(urn)}
                  updateMapCenter={(centerLatLng: { lat: number; lng: number }) =>
                    actionsMap.updateMapCenter(centerLatLng)
                  }
                  triggerImportModal={() => {
                    // setHideImportedTag(true);
                    navigate({ search: '?modalContent=import' });
                  }}
                  importButtonLabel={
                    <FormattedMessage id='ec.search.import' defaultMessage="Produkt-ID's importieren" />
                  }
                  kilometersLabel={<FormattedMessage id='ec.search.kilometers' defaultMessage='Kilometer' />}
                  metersLabel={<FormattedMessage id='ec.search.meters' defaultMessage='Meter' />}
                  radiusLabel={<FormattedMessage id='ec.search.radius' defaultMessage='Radius' />}
                  translations={{
                    places: {
                      label: intl.formatMessage({
                        id: 'ec.search.places.label',
                        defaultMessage: 'Orte (Städte, Gemeinden etc.)',
                      }),
                      description: intl.formatMessage({
                        id: 'ec.search.places.description',
                        defaultMessage: 'Bern, Geneva, Zürich...',
                      }),
                    },
                    address: {
                      label: intl.formatMessage({
                        id: 'ec.search.address.label',
                        defaultMessage: 'Adressen',
                      }),
                      description: intl.formatMessage({
                        id: 'ec.search.address.description',
                        defaultMessage: 'Bsp. Giesshübelstrasse 4, 8045 Zürich',
                      }),
                    },
                    cantons: {
                      label: intl.formatMessage({
                        id: 'ec.search.cantons.label',
                        defaultMessage: 'Kantone',
                      }),
                      description: intl.formatMessage({
                        id: 'ec.search.cantons.description',
                        defaultMessage: 'Zürich, Bern, Luzern, Uri, Schwyz, Obwalden...',
                      }),
                    },
                    traffic: {
                      label: intl.formatMessage({
                        id: 'ec.search.traffic.label',
                        defaultMessage: 'Verkehrsbetriebe',
                      }),
                      description: intl.formatMessage({
                        id: 'ec.search.traffic.description',
                        defaultMessage: 'Bernmobil, tl, SBB, ZVV...',
                      }),
                    },
                    postal: {
                      label: intl.formatMessage({
                        id: 'ec.search.postal.label',
                        defaultMessage: 'PLZ',
                      }),
                      description: intl.formatMessage({
                        id: 'ec.search.postal.description',
                        defaultMessage: '8045, 3004, 6003',
                      }),
                    },
                    id: {
                      label: intl.formatMessage({
                        id: 'ec.search.id.label',
                        defaultMessage: 'Produkt-ID',
                      }),
                      description: intl.formatMessage({
                        id: 'ec.search.id.description',
                        defaultMessage: '213201, 213202. 213203...',
                      }),
                    },
                    region: {
                      label: intl.formatMessage({
                        id: 'ec.search.regions.label',
                        defaultMessage: 'Regionen',
                      }),
                      description: intl.formatMessage({
                        id: 'ec.search.regions.description',
                        defaultMessage: 'Zürich, Bern, Lausanne...',
                      }),
                    },
                  }}
                />
              )}
            </div>

            <div className='map-wrapper'>
              {loading?.map && (
                <div className='h-100 w-100 position-absolute d-flex justify-content-center align-items-center z-1'>
                  <Spinner relative />
                </div>
              )}
              <Map
                center={userDataEC.mapCenter}
                locations={userDataEC.locations}
                updateLatLngRad={(
                  lat: number,
                  lng: number,
                  rad: number,
                  address: string,
                  types: string[],
                  newAddress?: string,
                ) => {
                  actionsJourney.updateCityLocation({
                    address,
                    newAddress: newAddress,
                    types,
                    circle: { radius: rad, radiusUnit: 'm' },
                    lngLtd: { lat, lng },
                  });
                }}
                showingProductInfoWindow
                onHighlightLocation={(urn: string) => actionsSearch.highlightLocation(urn)}
                highlightedLocation={userDataEC.highlightedLocation}
              />
            </div>
          </div>
        )}
        <BottomNavigation
          isDisabled={memoizedIsDisableButton(userDataEC.locations)}
          isResultsDisabled={memoizedIsDisableButton(userDataEC.locations)}
          isHasResultsJump={!memoizedIsDisableButton(userDataEC.locations)}
          isAgencyJourney={userDataEC.isAgencyJourney}
          changeAgencyInfoPanelVisibility={(value) => {
            actionsSujet.setAgencyInfoPanelVisibility(value);
          }}
          agencyInfoPanelVisibility={userDataEC.agencyInfoPanelVisibility}
          agencyData={userDataEC.agencyData}
        />
      </div>
    </div>
  );
};

function mapStateToProps(state: RootState, ownProps: any) {
  return {
    ...ownProps,
    ...state.app,
    ...state.router,
    locales: state.locales,
  };
}

function mapDispatchToProps(dispatch: Dispatch<_actions.ACTION>) {
  return {
    actionsJourney: bindActionCreators(_actionsJourney as any, dispatch),
    actionsSearch: bindActionCreators(_actionsSearch as any, dispatch),
    actionsMap: bindActionCreators(_actionsMap as any, dispatch),
    actionsProduct: bindActionCreators(_actionsProduct as any, dispatch),
    actionsSujet: bindActionCreators(_actionsSujet as any, dispatch),
    actionsBasket: bindActionCreators(_actionsBasket as any, dispatch),
    actionsFilters: bindActionCreators(_actionsFilters as any, dispatch),
    actionsUi: bindActionCreators(_actionsUi as any, dispatch),
    actions: bindActionCreators(_actions as any, dispatch),
    dispatch: dispatch,
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(Step1)));
